export const useLockBody = (fixBody = true) => {
  const state = useState('lock-body', () => ({ pageYOffset: 0, locked: false }))

  const pageYOffset = computed(() => state.value.pageYOffset)
  const locked = computed(() => state.value.locked)
  const classes = computed(() =>
    ['overflow-hidden'].concat(fixBody ? ['fixed', 'left-0', 'right-0'] : []),
  )

  const setLock = (lock: boolean) => {
    state.value.locked = lock

    if (lock) {
      state.value.pageYOffset = window.pageYOffset

      document.body.style.marginTop = `-${pageYOffset.value}px`
      document.body.classList.add(...classes.value)
    } else {
      document.body.style.marginTop = ''
      document.body.classList.remove(...classes.value)

      window.scrollTo({ left: 0, top: pageYOffset.value, behavior: 'instant' })
    }
  }

  return { setLock, pageYOffset, locked }
}
